import styled from 'styled-components'
import { SPACING, BORDER_RADIUS } from '../../../styles/theme'
import { SkeletonBox } from '../styles/SkeletonStyles'

const PageContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: ${SPACING.xxl};
  min-height: 80dvh;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.lg};
  width: 100%;
`

const Buttons = styled.div`
  display: flex;
  gap: ${SPACING.sm};
  margin-top: ${SPACING.sm};
`

export function SkeletonUpgradeSuccess() {
  return (
    <PageContainer>
      <Inner>
        <SkeletonBox $width="64px" $height="64px" $radius={BORDER_RADIUS.full} />
        <SkeletonBox $width="200px" $height="28px" $radius={BORDER_RADIUS.lg} />
        <SkeletonBox $width="340px" $height="16px" $radius={BORDER_RADIUS.sm} />
        <SkeletonBox $width="280px" $height="16px" $radius={BORDER_RADIUS.sm} />
        <Buttons>
          <SkeletonBox $width="140px" $height="36px" $radius={BORDER_RADIUS.lg} />
          <SkeletonBox $width="110px" $height="36px" $radius={BORDER_RADIUS.lg} />
        </Buttons>
      </Inner>
    </PageContainer>
  )
}
